module.exports = __webpack_public_path__ + "static/media/silhouette-photo-of-man-singing-on-stage-1916824.9886c912.jpg";